import { styled } from '@mui/material/styles'
import { Box } from '@mui/material'
import { LEGEND_COLOR_MAP_V2 } from '../../../../../constants'

const RIGHT_CONTENT = '220px'

export const GraphScaleWrapper = styled(Box)(`
    width: calc(100% - ${RIGHT_CONTENT});
    display: flex;
    justify-content: space-between;
    padding: 12px 0;
    
    & span {
        width: calc(100% / 7);
        display: flex;
        align-items: center;
        justify-content: center;
        font-size:13px;
        padding:0 5px;
    }

    & .txt1 { justify-content: start; color:${LEGEND_COLOR_MAP_V2.Negative}; border-left: 1px solid #7C868F;}
    & .txt2 { justify-content: start; color:${LEGEND_COLOR_MAP_V2.Negative}; border-left: 1px solid #7C868F;}
    & .txt3 { justify-content: start; color:${LEGEND_COLOR_MAP_V2.Negative}; border-left: 1px solid #7C868F;}
    & .txt4 { justify-content: center; color:#7C868F; width:20px;}
    & .txt5 { justify-content: end; color:${LEGEND_COLOR_MAP_V2.Positive}; border-right: 1px solid #7C868F;}
    & .txt6 { justify-content: end; color:${LEGEND_COLOR_MAP_V2.Positive}; border-right: 1px solid #7C868F;}
    & .txt7 { justify-content: end; color:${LEGEND_COLOR_MAP_V2.Positive}; border-right: 1px solid #7C868F;}

    &.tab2 {
        position: relative;
        &:before {
            content: '';
            position:absolute;
            top:0;
            left:-${RIGHT_CONTENT};
            border-top: 2px solid #F5F5F5;
            width:calc(100% + ${RIGHT_CONTENT});
            height:1px;
            display:flex;
        }
    }
`)
